import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

import styles from './styles.module.scss';

const PartSelectPanelField: FunctionComponent<Props> = ({
    assetId,
    className = '',
    onChange,
    onClose,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { isLoading, noItemsText, partItems } = useData({ assetId });

    const handleClick = (part: Item) => {
        onChange(part);
        onClose?.(part);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                className={styles.selectPanel}
                isLoading={isLoading}
                isSearchable={false}
                itemSelected={value}
                items={partItems}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onSelected={handleClick}
            />
        </Wrapper>
    );
};

export default PartSelectPanelField;
